import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import BindPage from './pages/BindPage';
import UserListPage from './pages/UserListPage';
import ReportPage from './pages/ReportPage';
import HistoryPage from './pages/HistoryPage';
import { getUsersFromStorage } from './utils/storage';
import './styles/App.css';

function App() {
  const [hasUsers, setHasUsers] = useState(false);

  useEffect(() => {
    const users = getUsersFromStorage();
    setHasUsers(users && users.length > 0);
  }, []);

  return (
    <Router>
      <div className="app">
        <Routes>
          <Route path="/bind" element={<BindPage onBindSuccess={() => setHasUsers(true)} />} />
          <Route path="/users" element={<UserListPage />} />
          <Route path="/report/:userId" element={<ReportPage />} />
          <Route path="/history/:userId" element={<HistoryPage />} />
          <Route path="/" element={<Navigate to={hasUsers ? "/users" : "/bind"} replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
